export default __webpack_public_path__ + "static/media/Sort_asc.4cbd169f.svg";